import React from "react";
import { NavLink } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

export const BtnAlmacenar = ({ gAlmacenar, children }) => {
  return (
    <>
      <button className="button is-small is-success" onClick={gAlmacenar}>
        <span className="icon">
          <i className="fas fa-cloud-upload-alt"></i>
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnAgregar = ({ children, nameE }) => (
  <NavLink
    className="button is-small is-success is-pulled-right"
    to={`/${nameE}/0`}
    activeClassName="navActive"
  >
    <span className="icon">
      <i className="fas fa-plus"></i>
    </span>
    {children ? <span>{children}</span> : ""}
  </NavLink>
);

export const BtnSeleccionar = ({ toggle, children }) => (
  <>
    <button className="button is-small is-primary" onClick={toggle}>
      <span className="icon">
        <i className="fas fa-circle"></i>
      </span>
      {children ? <span>{children}</span> : ""}
    </button>
  </>
);

export const BtnInfo = ({ id, children, gmodalInfo }) => {
  return (
    <>
      <button className="button is-small is-success" onClick={() => gmodalInfo(id)}>
        <span className="icon">
          <i className="fas fa-eye"></i>
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnDwnld = ({ id, children, gDwnld,modulo }) => {

  return (
    <>
      <button className="button is-small is-success" onClick={() => gDwnld(id,modulo)}>
        <span className="icon">
          <i className="fas fa-eye"></i>
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnDeleteFile = ({ gDeleteFile, children, id, modulo }) => {
  return (
    <>
      <button className="button is-small is-success" onClick={()=>gDeleteFile(id, modulo)}>
        <span className="icon">
          <i className="fas fa-trash-alt" />
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnModificar = ({ id, children, nameE }) => {
  return (
    <NavLink className="button is-small is-success" to={`/${nameE}/${id}`}>
      <span className="icon">
        <i className="fas fa-pencil-alt"></i>
      </span>
      {children ? <span>{children}</span> : ""}
    </NavLink>
  );
};

export const BtnActualizar = ({ actualizarElemento, children }) => {
  return (
    <>
      <button className="button is-small is-success" onClick={actualizarElemento}>
        <span className="icon">
          <i className="fas fa-user-edit"></i>
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnEliminar = ({ gestionarEliminar, children, id }) => {
  return (
    <>
      <button className="button is-small is-primary" onClick={gestionarEliminar} id={id}>
        <span className="icon">
          <i className="fas fa-trash-alt" />
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnBuscar = ({ gestionarBuscar, children }) => {
  return (
    <>
      <button className="button is-success" onClick={gestionarBuscar}>
        <i className="fas fa-search"></i>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnAnterior = ({ gestionarAnterior, children }) => {
  return (
    <>
      <button
        className="button is-small is-success is-pulled-left"
        onClick={gestionarAnterior}
        disabled={gestionarAnterior === null ? true : false}
      >
        <span className="icon">
          <i className="fas fa-angle-left"></i>
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const BtnSiguiente = ({ gestionarSiguiente, children }) => {
  return (
    <>
      <button
        className="button is-small is-success is-pulled-right"
        onClick={gestionarSiguiente}
        disabled={gestionarSiguiente === null ? true : false}
      >
        <span className="icon">
          <i className="fas fa-angle-right"></i>
        </span>
        {children ? <span>{children}</span> : ""}
      </button>
    </>
  );
};

export const MenuCantidad = ({ gestionarCantidad, total, can }) => {
  /* 
    Logica:
        - si el total de resultados es menor que 5, entonces no mostrar select
        - si el total de resultados es mayor a 10, entonces crear menu
        - ¿como calcular la cantidad de options para generar el menu?
    */

  if (total <= 5) return "-";
  else
    return (
      <>
        <div className="select">
          <select value={can} onChange={gestionarCantidad}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </>
    );
};
